import React from 'react';

import ClaimStepContainer from '../common/ClaimStepContainer';

function InvestigationStepContainer(props) {
  return <ClaimStepContainer {...props} subHeading="INVESTIGATION_CLAIM_FLOW_HEADING" confirmExit />;
}

export default React.memo(InvestigationStepContainer);
